import React, { useState, useEffect } from 'react';
import { FiChevronDown, FiArrowRight } from 'react-icons/fi';
import { FiFacebook, FiTwitter, FiInstagram, FiYoutube, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import './BiographyPage.css';
import './NewsArticlesPage.css';

const NewsArticlesPage = ({ onBack, onNavigate }) => {
  const [newsArticles, setNewsArticles] = useState([]);
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await fetch('http://localhost:3001/api/articles?status=published');
      const data = await response.json();
      
      // Separate news and articles based on category
      const news = data.filter(item => item.category === 'news' || item.category === 'announcements');
      const articles = data.filter(item => item.category !== 'news' && item.category !== 'announcements');
      
      setNewsArticles(news);
      setPublications(articles);
    } catch (error) {
      console.error('Failed to fetch articles:', error);
      // Keep empty arrays if fetch fails
    } finally {
      setLoading(false);
    }
  };
  const navigate = (target) => {
    if (onNavigate) onNavigate(target);
    else if (onBack) onBack();
  };

  return (
    <div className="nap-page">

      {/* Navbar */}
      <nav className="bio-navbar">
        <div className="bio-navbar-logo">
          <img src="/Sndp/logo.png" alt="Pravasi SNDP Yogam Logo" />
        </div>
        <div className="bio-navbar-links">
          <div className="bio-nav-menu">
            <a href="#home" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('home'); }}>Home</a>
            <div className="bio-nav-about-wrapper">
              <span className="bio-nav-link bio-nav-dropdown">
                About <FiChevronDown size={14} />
              </span>
              <div className="bio-nav-about-dropdown">
                <button onClick={() => navigate('ourhistory')}>Our History</button>
                <button onClick={() => navigate('leadership')}>Leadership</button>
              </div>
            </div>
            <a href="#gallery" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('gallery'); }}>Gallery</a>
            <a href="#news" className="bio-nav-link" style={{ fontWeight: 700, color: '#000000' }}>News &amp; Articles</a>
            <a href="#eventcalendar" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('eventcalendar'); }}>Event Calendar</a>
            <a href="#constitution" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('constitution'); }}>Constitution</a>
            <a href="#membership" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('membership'); }}>Membership</a>
            <a href="#contact" className="bio-nav-link" onClick={(e) => { e.preventDefault(); navigate('contact'); }}>Contact Us</a>
          </div>
          <a href="#donate" className="bio-donate-btn">Donation</a>
        </div>
      </nav>

      {/* ── Section 1: Latest News ── */}
      <section className="nap-section">
        <div className="nap-inner">
          <div className="nap-header-row">
            <h2 className="nap-section-title">Latest News</h2>
            <div className="nap-header-divider"></div>
          </div>

          {loading ? (
            <p style={{ textAlign: 'center', padding: '2rem' }}>Loading news...</p>
          ) : newsArticles.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '2rem' }}>No news articles available yet.</p>
          ) : (
            <div className="nap-news-grid">
              {newsArticles.map((item, i) => (
                <div className="nap-news-card" key={item.id || i}>
                  <div
                    className="nap-card-image"
                    style={{ backgroundImage: `url('${item.featuredImage || '/Sndp/logo.png'}')` }}
                  />
                  <div className="nap-card-body">
                    <div>
                      <div className="nap-card-date">
                        <span className="nap-card-date-dot" />
                        <span>{new Date(item.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                      </div>
                      <h3 className="nap-card-title">{item.title}</h3>
                      <p className="nap-card-desc">{item.content.substring(0, 150)}...</p>
                    </div>
                    <button className="nap-card-link">
                      Read full story <FiArrowRight size={12} color="#FFC501" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ── Section 2: Articles & Publications ── */}
      <section className="nap-section-2">
        <div className="nap-inner">
          <div className="nap-header-stack">
            <h2 className="nap-section-title">Articles &amp; Publications</h2>
            <p className="nap-header-subtitle">Explore our latest writings and research papers</p>
          </div>

          {loading ? (
            <p style={{ textAlign: 'center', padding: '2rem' }}>Loading articles...</p>
          ) : publications.length === 0 ? (
            <p style={{ textAlign: 'center', padding: '2rem' }}>No articles available yet.</p>
          ) : (
            <div className="nap-articles-grid">
              {publications.map((pub, i) => (
                <div className="nap-article-card" key={pub.id || i}>
                  <div
                    className="nap-article-img"
                    style={{ backgroundImage: `url('${pub.featuredImage || '/Sndp/logo.png'}')` }}
                  />
                  <div className="nap-article-content">
                    <p className="nap-article-tag">Article</p>
                    <h3 className="nap-article-title">{pub.title}</h3>
                    <p className="nap-article-author">By {pub.author}</p>
                    <p className="nap-article-desc">{pub.content.substring(0, 120)}...</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="bio-footer">
        <div className="bio-footer-main">
          <div className="bio-footer-brand">
            <div className="bio-footer-logo-row">
              <img src="/Sndp/logo.png" alt="Logo" className="bio-footer-logo-img" />
              <div className="bio-footer-brand-info">
                <h3 className="bio-footer-brand-name">Pravasi SNDP Yogam, UK Bristol</h3>
                <p className="bio-footer-brand-desc">
                  We, Pravasi SNDP Yogam members, are the devotees of Sree Narayana Guru,
                  a revered saint and social reformer from Kerala, India (1854-1928).
                </p>
                <div className="bio-footer-socials">
                  <a href="#facebook" aria-label="Facebook"><FiFacebook size={20} color="#FFC501" /></a>
                  <a href="#twitter" aria-label="Twitter"><FiTwitter size={20} color="#FFC501" /></a>
                  <a href="#instagram" aria-label="Instagram"><FiInstagram size={20} color="#FFC501" /></a>
                  <a href="#youtube" aria-label="YouTube"><FiYoutube size={28} color="#FFC501" /></a>
                </div>
              </div>
            </div>
          </div>

          <div className="bio-footer-contact">
            <h4 className="bio-footer-column-title">Contact Us</h4>
            <div className="bio-footer-contact-list">
              <div className="bio-footer-contact-item">
                <FiMapPin size={20} color="#FFC501" />
                <span>Almondsbury Creative 10 Gloucester Road, Bristol</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiPhone size={20} color="#FFC501" />
                <span>+91 84524145547</span>
              </div>
              <div className="bio-footer-contact-item">
                <FiMail size={20} color="#FFC501" />
                <span>sndpyogamuk@gmail.com</span>
              </div>
            </div>
          </div>

          <div className="bio-footer-links">
            <h4 className="bio-footer-column-title">Quick Links</h4>
            <ul className="bio-footer-nav">
              <li><a href="#home" onClick={onBack}>Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#history">History</a></li>
              <li><a href="#organization">Organization</a></li>
              <li><a href="#sree-narayana-guru">Sree Narayana Guru</a></li>
              <li><a href="#articles">Articles</a></li>
              <li><a href="#gallery" onClick={(e) => { e.preventDefault(); navigate('gallery'); }}>Gallery</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); navigate('contact'); }}>Contact</a></li>
            </ul>
          </div>

          <div className="bio-footer-newsletter">
            <h4 className="bio-footer-column-title">Newsletter</h4>
            <p className="bio-newsletter-desc">Subscribe to our Newsletter</p>
            <div className="bio-newsletter-form">
              <input type="email" placeholder="Enter your email" />
              <button type="button">Subscribe</button>
            </div>
          </div>
        </div>

        <div className="bio-footer-bottom">
          <span>© 2025 Pravasi SNDP Yogam. All rights reserved.</span>
          <div className="bio-footer-bottom-links">
            <a href="#terms">Terms of Use</a>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
      </footer>

    </div>
  );
};

export default NewsArticlesPage;
